import { useMemo } from 'react';
import { isNumber } from 'lodash-es';
import { useGameRoundData } from './useGameRoundData.ts';
import { useNextRoundNumber } from './useNextRoundNumber.ts';

export const useGetRoundNumberByType = (round: 'prev' | 'current' | 'next') => {
  const { data: roundData } = useGameRoundData();
  const nextRoundNumber = useNextRoundNumber();

  return useMemo(() => {
    switch (round) {
      // Use similar logic as for useNextRoundNumber?
      case 'prev':
        return isNumber(roundData?.round) ? roundData?.round - 1 : undefined;
      case 'current':
        return roundData?.round;
      case 'next':
        return nextRoundNumber ?? undefined;
    }
  }, [round, roundData?.round, nextRoundNumber]);
};

export type RoundType = 'prev' | 'current' | 'next';
